import { RefObject, useEffect, useRef, useState } from 'react';
import VimeoPlayer from '@vimeo/player';

import { UploadedFileVideo } from '@/component/FileUpload/types';

export const useFormRecordingVimeoPlayer = ({
  uploadedFileVideo,
}: {
  uploadedFileVideo: UploadedFileVideo;
}): {
  videoRef: RefObject<HTMLDivElement>;
} => {
  const videoRef = useRef<HTMLDivElement>(null);
  const [, setVimeoPlayer] = useState<VimeoPlayer>();

  const createPlayer = () => {
    if (uploadedFileVideo?.vimeoId && videoRef.current) {
      return new VimeoPlayer(videoRef.current, {
        id: parseInt(uploadedFileVideo?.vimeoId),
        speed: true,
        responsive: true,
      });
    }

    return null;
  };

  useEffect(() => {
    // Small delay to ensure the container has been rendered
    const timeoutId = setTimeout(() => {
      const player = createPlayer();

      if (player) {
        setVimeoPlayer(player);
      }
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [uploadedFileVideo]);

  return {
    videoRef,
  };
};
